/**
 * Carousel drag guard (E20-1583)
 *
 * Stops the browser's native drag from hijacking drag-to-scroll. Every house
 * carousel arms its drag only after 5px of pointer movement, so that a click can
 * still reach links inside the track — but the browser fires `dragstart` on an
 * image or a link on the very first pixel. Native drag-and-drop then swallows the
 * `pointermove` events, the 5px threshold is never reached, and the track sits
 * still while a ghost of the image follows the cursor.
 *
 * One delegated listener rather than a line in each carousel: all six sections
 * that render a track share the `[data-carousel-track]` hook, the four carousel
 * classes already duplicate the drag logic between them, and delegation also
 * covers tracks injected after load — the PDP recommendations row and Recently
 * Viewed both arrive via innerHTML.
 *
 * Scoped to the track, so ordinary image dragging elsewhere on the storefront is
 * untouched. Text selection is unaffected: this suppresses dragging a selection,
 * not making one.
 */
document.addEventListener('dragstart', (event) => {
  if (event.target.closest?.('[data-carousel-track]')) event.preventDefault();
});
